// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"986322bb","453":"44d9f53c"}[chunkId] + ".chunk.js";
};